module.exports = __webpack_public_path__ + "img/cinta4.6921e3fc.png";